export default {
    'Menu': 'منو'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/core/oncanvas/translations/fa.js
// module id = 471
// module chunks = 0